import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { UpcomingTrips } from './components/UpcomingTrips';
import { AllHikingTrips } from './components/AllHikingTrips';
import { CustomerExperience } from './components/CustomerExperience';
import { RecentBlogs } from './components/RecentBlogs';
import { STOGarantBanner } from './components/STOGarantBanner';
import { Footer } from './components/Footer';
import GreecePage from './pages/Greece';
import CyprusPage from './pages/Cyprus';
import SpainPage from './pages/Spain';
import AboutPage from './pages/About';
import ContactPage from './pages/Contact';
import JoinPage from './pages/Join';
import SpringHikingTrips from './pages/SpringHikingTrips';
export function App() {
  return <Routes data-id="element-0">
      <Route path="/" element={<div className="flex flex-col min-h-screen w-full" data-id="element-2">
            <Header data-id="element-3" />
            <main className="flex-grow" data-id="element-4">
              <HeroSection data-id="element-5" />
              <UpcomingTrips data-id="element-6" />
              <AllHikingTrips data-id="element-7" />
              <CustomerExperience data-id="element-8" />
              <RecentBlogs data-id="element-9" />
              <STOGarantBanner data-id="element-10" />
            </main>
            <Footer data-id="element-11" />
          </div>} data-id="element-1" />
      <Route path="/greece" element={<GreecePage data-id="element-13" />} data-id="element-12" />
      <Route path="/cyprus" element={<CyprusPage data-id="element-15" />} data-id="element-14" />
      <Route path="/spain" element={<SpainPage data-id="element-17" />} data-id="element-16" />
      <Route path="/about" element={<AboutPage data-id="element-19" />} data-id="element-18" />
      <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
      <Route path="/join" element={<JoinPage data-id="element-23" />} data-id="element-22" />
      <Route path="/greece/spring-hiking" element={<SpringHikingTrips data-id="element-25" />} data-id="element-24" />
    </Routes>;
}